import "../../style/store/store product/SP_BuyBox.css";

import { FiCheck } from "react-icons/fi";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators } from "../../../redux/index";

let bybox_info = [
  {
    id: 1,
    text: "در این قسمت ویژگی های آزمون قرار می‌گیرد",
  },
  {
    id: 2,
    text: "بازگشت وجه در صورت عدم رضایت ",
  },
  {
    id: 3,
    text: "ارائه کارنامه به دانش آموزان",
  },
  {
    id: 4,
    text: "مشاهده رتبه استانی",
  },
  {
    id: 5,
    text: "هزاران ویژگی جالب دیگر",
  },
];

const SP_BuyBox = ({ discount, discounted_price, price, ID }) => {
  const dispatch = useDispatch();
  const { addToCart } = bindActionCreators(actionCreators, dispatch);
  // console.log("data:"+data);

  return (
    <div className="sp-bybox">
      {discount && (
        <div className="sp-bybox-discount-and-old-price">
          <div className="sp-bdaop-discount">{discount}</div>
          <div className="sp-bdaop-old-price">
            {price} <span>تومان</span>
          </div>
        </div>
      )}
      <div
        style={!discount ? { marginTop: "0px" } : null}
        className="sp-bybox-main-price"
      >
        {discount && discounted_price}
        {!discount && price}
        <span>تومان</span>
      </div>
      <div className="sp-bybox-info">
        <div className="sp-bybox-info-title">ویژگی‌ها در صورت خرید محصول</div>
        {bybox_info.map((item) => (
          <div className="sp-bybox-info-item" key={item.id}>
            <FiCheck className="sp-bybox-info-item-icon" />
            <div className="sp-bybox-info-item-text">{item.text}</div>
          </div>
        ))}
      </div>
      <div className="sp-bybox-btn" onClick={() => addToCart(ID)}>
        افزودن به سبد خرید
      </div>
    </div>
  );
};

export default SP_BuyBox;
